import { Page } from "@/models/page-models/Page";

export const ClosingInventory: Page = {
  "path": "closing-inventory",
  "name": "Closing Inventory",
  "props": {
    "data": {
      "title": "Closing Inventory",
      "printable": "FALSE",
      "url": "closing-inventory",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "warehouse",
              "bracketValueFormula": "fn(SUM,{{fetchedData.warehouseRm.data.totalDocs}},{{fetchedData.warehouseFg.data.totalDocs}},{{fetchedData.warehouseWip.data.totalDocs}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "tabs",
                      "tabItems": [
                        {
                          "tabName": "RM",
                          "bracketValueFormula": "{{fetchedData.warehouseRm.data.totalDocs}}",
                          "rows": [
                            {
                              "name": "1",
                              "pageItems": [
                                {
                                  "type": "table",
                                  "variable": "formData.warehouse.RM",
                                  "label": "warehouse",
                                  "disabled": "FALSE",
                                  "items": "fetchedData.warehouseRm.data.docs",
                                  "headers": [
                                    {
                                      "value": "__item._id",
                                      "text": "RM#"
                                    },
                                    {
                                      "value": "__item.type",
                                      "text": "RM Type"
                                    },
                                    {
                                      "value": "__item.details",
                                      "text": "Good Details",
                                      "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                                    },
                                    {
                                      "value": "__item.density",
                                      "text": "Density",
                                      "type": "formula",
                                      "formula": "{{__item.density}} {{__item.densityUnit}}"
                                    },
                                    {
                                      "value": "__item.quantity",
                                      "text": "Quantity",
                                      "type": "text"
                                    }
                                  ],
                                  "tableType": "dynamic",
                                  "variableKey": "_id",
                                  "itemKey": "_id",
                                  "validationVariable": "warehouseRM",
                                  "pagination": {
                                    "pageVariable": "formData.rmWarehouseForm.page",
                                    "itemsPerPageVariable": "formData.rmWarehouseForm.limit",
                                    "serverItemsLengthVariable": "fetchedData.warehouseRm.data.totalDocs",
                                    "pageChangeFns": [
                                      {
                                        "executionOrder": 2,
                                        "pageFunction": {
                                          "name": "getRmWarehouseGoods",
                                          "type": "fnGetData",
                                          "arg1Key": "apiUrl",
                                          "arg1Value": "/api/v2/goods/search",
                                          "arg2Key": "postData",
                                          "arg2Value": "formData.rmWarehouseForm",
                                          "arg3Key": "storeInVar",
                                          "arg3Value": "fetchedData.warehouseRm"
                                        },
                                        "name": "getRmWarehouseGoods"
                                      },
                                      {
                                        "executionOrder": 3,
                                        "pageFunction": {
                                          "name": "createWarehouseRmVariableArray",
                                          "type": "fnCreateArray",
                                          "arg1Key": "sourceVariable",
                                          "arg1Value": "fetchedData.warehouseRm.data.docs",
                                          "arg2Key": "destinationVariable",
                                          "arg2Value": "formData.warehouse.RM",
                                          "arg3Key": "arrayTransformationFn",
                                          "arg3Value": "getGoodsVariable"
                                        },
                                        "name": "createWarehouseRmVariableArray"
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "2",
                              "pageItems": [
                                {
                                  "type": "button",
                                  "label": "Submit",
                                  "onClick": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "submitWarehouseRMClosing",
                                        "type": "fnSubmit",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/closing-adjustment/Warehouse",
                                        "arg2Key": "postData",
                                        "arg2Value": "getWarehouseRmData",
                                        "arg3Key": "refreshPage",
                                        "arg3Value": "TRUE"
                                      },
                                      "name": "submitWarehouseRMClosing"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "color": "primary"
                                }
                              ]
                            }
                          ],
                          "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
                        },
                        {
                          "tabName": "FG",
                          "bracketValueFormula": "{{fetchedData.warehouseFg.data.totalDocs}}",
                          "rows": [
                            {
                              "name": "1",
                              "pageItems": [
                                {
                                  "type": "dropdown",
                                  "variable": "formData.fgWarehouseForm.customer",
                                  "label": "Filter By Customer",
                                  "onChange": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "copyDefaultFgPageNo",
                                        "type": "fnCopyData",
                                        "arg1Key": "sourceFn",
                                        "arg1Value": "getDefaultPageNo",
                                        "arg2Key": "destinationKey",
                                        "arg2Value": "formData.fgWarehouseForm",
                                        "arg3Key": "append",
                                        "arg3Value": "TRUE",
                                        "arg4Key": "destinationKeyType",
                                        "arg4Value": "Object"
                                      },
                                      "name": "copyDefaultFgPageNo"
                                    },
                                    {
                                      "executionOrder": 3,
                                      "pageFunction": {
                                        "name": "getFgWarehouseGoods",
                                        "type": "fnGetData",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/search",
                                        "arg2Key": "postData",
                                        "arg2Value": "formData.fgWarehouseForm",
                                        "arg3Key": "storeInVar",
                                        "arg3Value": "fetchedData.warehouseFg"
                                      },
                                      "name": "getFgWarehouseGoods"
                                    },
                                    {
                                      "executionOrder": 4,
                                      "pageFunction": {
                                        "name": "createWarehouseFgVariableArray",
                                        "type": "fnCreateArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "fetchedData.warehouseFg.data.docs",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "formData.warehouse.FG",
                                        "arg3Key": "arrayTransformationFn",
                                        "arg3Value": "getFgVariable"
                                      },
                                      "name": "createWarehouseFgVariableArray"
                                    },
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "copyProductsForm",
                                        "type": "fnCopyData",
                                        "arg1Key": "sourceFn",
                                        "arg1Value": "getDefaultProductForm",
                                        "arg2Key": "destinationKey",
                                        "arg2Value": "fetchedData.whFgProductForm"
                                      },
                                      "name": "copyProductsForm"
                                    },
                                    {
                                      "executionOrder": 2,
                                      "pageFunction": {
                                        "name": "pushCustomerIdToProductForm",
                                        "type": "fnPushToArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "formData.fgWarehouseForm.customer",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "fetchedData.whFgProductForm.q.customer"
                                      },
                                      "name": "pushCustomerIdToProductForm"
                                    },
                                    {
                                      "executionOrder": 3,
                                      "pageFunction": {
                                        "name": "getProducts",
                                        "type": "fnGetData",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v1/product/search",
                                        "arg2Key": "postData",
                                        "arg2Value": "fetchedData.whFgProductForm",
                                        "arg3Key": "storeInVar",
                                        "arg3Value": "fetchedData.fgWhProducts"
                                      },
                                      "name": "getProducts"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "items": "fetchedData.customers.data",
                                  "itemText": "name",
                                  "itemValue": "_id",
                                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                                },
                                {
                                  "type": "dropdown",
                                  "variable": "formData.fgWarehouseForm.product",
                                  "label": "Filter By Product",
                                  "disabled": "FALSE",
                                  "onChange": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "copyDefaultFgPageNo",
                                        "type": "fnCopyData",
                                        "arg1Key": "sourceFn",
                                        "arg1Value": "getDefaultPageNo",
                                        "arg2Key": "destinationKey",
                                        "arg2Value": "formData.fgWarehouseForm",
                                        "arg3Key": "append",
                                        "arg3Value": "TRUE",
                                        "arg4Key": "destinationKeyType",
                                        "arg4Value": "Object"
                                      },
                                      "name": "copyDefaultFgPageNo"
                                    },
                                    {
                                      "executionOrder": 3,
                                      "pageFunction": {
                                        "name": "getFgWarehouseGoods",
                                        "type": "fnGetData",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/search",
                                        "arg2Key": "postData",
                                        "arg2Value": "formData.fgWarehouseForm",
                                        "arg3Key": "storeInVar",
                                        "arg3Value": "fetchedData.warehouseFg"
                                      },
                                      "name": "getFgWarehouseGoods"
                                    },
                                    {
                                      "executionOrder": 4,
                                      "pageFunction": {
                                        "name": "createWarehouseFgVariableArray",
                                        "type": "fnCreateArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "fetchedData.warehouseFg.data.docs",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "formData.warehouse.FG",
                                        "arg3Key": "arrayTransformationFn",
                                        "arg3Value": "getFgVariable"
                                      },
                                      "name": "createWarehouseFgVariableArray"
                                    }
                                  ],
                                  "items": "fetchedData.fgWhProducts.data.docs",
                                  "itemText": "alias",
                                  "itemValue": "_id",
                                  "formula": "fn(CONCAT,{{__item._id}}, ,fn(HELPER_FN,productAlias,{{__item}}))"
                                }
                              ]
                            },
                            {
                              "name": "2",
                              "pageItems": [
                                {
                                  "type": "table",
                                  "variable": "formData.warehouse.FG",
                                  "label": "warehouse",
                                  "disabled": "FALSE",
                                  "items": "fetchedData.warehouseFg.data.docs",
                                  "headers": [
                                    {
                                      "value": "__item._id",
                                      "text": "FG#"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order._id",
                                      "text": "Order #",
                                      "type": "url",
                                      "url": "/order/{{__item.factoryTicket.order._id}}"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order.product._id",
                                      "text": "Product",
                                      "type": "formula",
                                      "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order.customer._id",
                                      "text": "Customer",
                                      "type": "formula",
                                      "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order.unit.unit2",
                                      "text": "Selling Unit"
                                    },
                                    {
                                      "value": "__item.quantity",
                                      "text": "Quantity",
                                      "type": "text"
                                    }
                                  ],
                                  "tableType": "dynamic",
                                  "variableKey": "_id",
                                  "itemKey": "_id",
                                  "validationVariable": "warehouseFG",
                                  "pagination": {
                                    "pageVariable": "formData.fgWarehouseForm.page",
                                    "itemsPerPageVariable": "formData.fgWarehouseForm.limit",
                                    "serverItemsLengthVariable": "fetchedData.warehouseFg.data.totalDocs",
                                    "pageChangeFns": [
                                      {
                                        "executionOrder": 2,
                                        "pageFunction": {
                                          "name": "getFgWarehouseGoods",
                                          "type": "fnGetData",
                                          "arg1Key": "apiUrl",
                                          "arg1Value": "/api/v2/goods/search",
                                          "arg2Key": "postData",
                                          "arg2Value": "formData.fgWarehouseForm",
                                          "arg3Key": "storeInVar",
                                          "arg3Value": "fetchedData.warehouseFg"
                                        },
                                        "name": "getFgWarehouseGoods"
                                      },
                                      {
                                        "executionOrder": 3,
                                        "pageFunction": {
                                          "name": "createWarehouseFgVariableArray",
                                          "type": "fnCreateArray",
                                          "arg1Key": "sourceVariable",
                                          "arg1Value": "fetchedData.warehouseFg.data.docs",
                                          "arg2Key": "destinationVariable",
                                          "arg2Value": "formData.warehouse.FG",
                                          "arg3Key": "arrayTransformationFn",
                                          "arg3Value": "getFgVariable"
                                        },
                                        "name": "createWarehouseFgVariableArray"
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "3",
                              "pageItems": [
                                {
                                  "type": "button",
                                  "label": "Submit",
                                  "onClick": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "createFactoryFgVariableFormArray",
                                        "type": "fnCreateArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "formData.warehouse.FG",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "formData.resolvedWhFG",
                                        "arg3Key": "arrayTransformationFn",
                                        "arg3Value": "getResolvedFgVariable"
                                      },
                                      "name": "createFactoryFgVariableFormArray"
                                    },
                                    {
                                      "executionOrder": 2,
                                      "pageFunction": {
                                        "name": "submitWarehouseFGClosing",
                                        "type": "fnSubmit",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/closing-adjustment/Warehouse",
                                        "arg2Key": "postData",
                                        "arg2Value": "getWarehouseFgData",
                                        "arg3Key": "refreshPage",
                                        "arg3Value": "TRUE"
                                      },
                                      "name": "submitWarehouseFGClosing"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "color": "primary"
                                }
                              ]
                            }
                          ],
                          "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
                        },
                        {
                          "tabName": "WIP",
                          "bracketValueFormula": "{{fetchedData.warehouseWip.data.totalDocs}}",
                          "rows": [
                            {
                              "name": "1",
                              "pageItems": [
                                {
                                  "type": "table",
                                  "variable": "formData.warehouse.WIP",
                                  "label": "warehouse",
                                  "disabled": "FALSE",
                                  "items": "fetchedData.warehouseWip.data.docs",
                                  "headers": [
                                    {
                                      "value": "__item._id",
                                      "text": "WIP#"
                                    },
                                    {
                                      "value": "__item.details",
                                      "text": "Good Details",
                                      "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                                    },
                                    {
                                      "value": "__item.density",
                                      "text": "Density",
                                      "type": "formula",
                                      "formula": "{{__item.density}} {{__item.densityUnit}}"
                                    },
                                    {
                                      "value": "__item.quantity",
                                      "text": "Quantity",
                                      "type": "text"
                                    }
                                  ],
                                  "tableType": "dynamic",
                                  "variableKey": "_id",
                                  "itemKey": "_id",
                                  "validationVariable": "warehouseWIP",
                                  "pagination": {
                                    "pageVariable": "formData.wipWarehouseForm.page",
                                    "itemsPerPageVariable": "formData.wipWarehouseForm.limit",
                                    "serverItemsLengthVariable": "fetchedData.warehouseWip.data.totalDocs",
                                    "pageChangeFns": [
                                      {
                                        "executionOrder": 2,
                                        "pageFunction": {
                                          "name": "getWipWarehouseGoods",
                                          "type": "fnGetData",
                                          "arg1Key": "apiUrl",
                                          "arg1Value": "/api/v2/goods/search",
                                          "arg2Key": "postData",
                                          "arg2Value": "formData.wipWarehouseForm",
                                          "arg3Key": "storeInVar",
                                          "arg3Value": "fetchedData.warehouseWip"
                                        },
                                        "name": "getWipWarehouseGoods"
                                      },
                                      {
                                        "executionOrder": 3,
                                        "pageFunction": {
                                          "name": "createWarehouseWipVariableArray",
                                          "type": "fnCreateArray",
                                          "arg1Key": "sourceVariable",
                                          "arg1Value": "fetchedData.warehouseWip.data.docs",
                                          "arg2Key": "destinationVariable",
                                          "arg2Value": "formData.warehouse.WIP",
                                          "arg3Key": "arrayTransformationFn",
                                          "arg3Value": "getGoodsVariable"
                                        },
                                        "name": "createWarehouseWipVariableArray"
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "2",
                              "pageItems": [
                                {
                                  "type": "button",
                                  "label": "Submit",
                                  "onClick": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction":       {
                                        "name": "submitWarehouseWIPClosing",
                                        "type": "fnSubmit",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/closing-adjustment/Warehouse",
                                        "arg2Key": "postData",
                                        "arg2Value": "getWarehouseWipData",
                                        "arg3Key": "refreshPage",
                                        "arg3Value": "TRUE"
                                      },
                                      "name": "submitWarehouseWIPClosing"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "color": "primary"
                                }
                              ]
                            }
                          ],
                          "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "factory",
              "bracketValueFormula": "fn(SUM,{{fetchedData.factoryRm.data.totalDocs}},{{fetchedData.factoryFg.data.totalDocs}},{{fetchedData.factoryWip.data.totalDocs}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "tabs",
                      "tabItems": [
                        {
                          "tabName": "RM",
                          "bracketValueFormula": "{{fetchedData.factoryRm.data.totalDocs}}",
                          "rows": [
                            {
                              "name": "1",
                              "pageItems": [
                                {
                                  "type": "table",
                                  "variable": "formData.factory.RM",
                                  "label": "factory",
                                  "disabled": "FALSE",
                                  "items": "fetchedData.factoryRm.data.docs",
                                  "headers": [
                                    {
                                      "value": "__item._id",
                                      "text": "RM#"
                                    },
                                    {
                                      "value": "__item.type",
                                      "text": "RM Type"
                                    },
                                    {
                                      "value": "__item.details",
                                      "text": "Good Details",
                                      "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                                    },
                                    {
                                      "value": "__item.density",
                                      "text": "Density",
                                      "type": "formula",
                                      "formula": "{{__item.density}} {{__item.densityUnit}}"
                                    },
                                    {
                                      "value": "__item.quantity",
                                      "text": "Quantity",
                                      "type": "text"
                                    }
                                  ],
                                  "tableType": "dynamic",
                                  "variableKey": "_id",
                                  "itemKey": "_id",
                                  "validationVariable": "factoryRM",
                                  "pagination": {
                                    "pageVariable": "formData.rmFactoryForm.page",
                                    "itemsPerPageVariable": "formData.rmFactoryForm.limit",
                                    "serverItemsLengthVariable": "fetchedData.factoryRm.data.totalDocs",
                                    "pageChangeFns": [
                                      {
                                        "executionOrder": 2,
                                        "pageFunction": {
                                          "name": "getRmFactoryGoods",
                                          "type": "fnGetData",
                                          "arg1Key": "apiUrl",
                                          "arg1Value": "/api/v2/goods/search",
                                          "arg2Key": "postData",
                                          "arg2Value": "formData.rmFactoryForm",
                                          "arg3Key": "storeInVar",
                                          "arg3Value": "fetchedData.factoryRm"
                                        },
                                        "name": "getRmFactoryGoods"
                                      },
                                      {
                                        "executionOrder": 3,
                                        "pageFunction": {
                                          "name": "createFactoryRmVariableArray",
                                          "type": "fnCreateArray",
                                          "arg1Key": "sourceVariable",
                                          "arg1Value": "fetchedData.factoryRm.data.docs",
                                          "arg2Key": "destinationVariable",
                                          "arg2Value": "formData.factory.RM",
                                          "arg3Key": "arrayTransformationFn",
                                          "arg3Value": "getGoodsVariable"
                                        },
                                        "name": "createFactoryRmVariableArray"
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "2",
                              "pageItems": [
                                {
                                  "type": "button",
                                  "label": "Submit",
                                  "onClick": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "submitFactoryRMClosing",
                                        "type": "fnSubmit",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/closing-adjustment/Factory",
                                        "arg2Key": "postData",
                                        "arg2Value": "getFactoryRmData",
                                        "arg3Key": "refreshPage",
                                        "arg3Value": "TRUE"
                                      },
                                      "name": "submitFactoryRMClosing"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "color": "primary"
                                }
                              ]
                            }
                          ],
                          "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
                        },
                        {
                          "tabName": "FG",
                          "bracketValueFormula": "{{fetchedData.factoryFg.data.totalDocs}}",
                          "rows": [
                            {
                              "name": "1",
                              "pageItems": [
                                {
                                  "type": "dropdown",
                                  "variable": "formData.fgFactoryForm.customer",
                                  "label": "Filter By Customer",
                                  "onChange": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "copyDefaultFgPageNo",
                                        "type": "fnCopyData",
                                        "arg1Key": "sourceFn",
                                        "arg1Value": "getDefaultPageNo",
                                        "arg2Key": "destinationKey",
                                        "arg2Value": "formData.fgFactoryForm",
                                        "arg3Key": "append",
                                        "arg3Value": "TRUE",
                                        "arg4Key": "destinationKeyType",
                                        "arg4Value": "Object"
                                      },
                                      "name": "copyDefaultFgPageNo"
                                    },
                                    {
                                      "executionOrder": 3,
                                      "pageFunction": {
                                        "name": "getFgFactoryGoods",
                                        "type": "fnGetData",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/search",
                                        "arg2Key": "postData",
                                        "arg2Value": "formData.fgFactoryForm",
                                        "arg3Key": "storeInVar",
                                        "arg3Value": "fetchedData.factoryFg"
                                      },
                                      "name": "getFgFactoryGoods"
                                    },
                                    {
                                      "executionOrder": 4,
                                      "pageFunction": {
                                        "name": "createFactoryFgVariableArray",
                                        "type": "fnCreateArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "fetchedData.factoryFg.data.docs",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "formData.factory.FG",
                                        "arg3Key": "arrayTransformationFn",
                                        "arg3Value": "getFgVariable"
                                      },
                                      "name": "createFactoryFgVariableArray"
                                    },
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "copyProductsForm",
                                        "type": "fnCopyData",
                                        "arg1Key": "sourceFn",
                                        "arg1Value": "getDefaultProductForm",
                                        "arg2Key": "destinationKey",
                                        "arg2Value": "fetchedData.factoryFgProductForm"
                                      },
                                      "name": "copyProductsForm"
                                    },
                                    {
                                      "executionOrder": 2,
                                      "pageFunction": {
                                        "name": "pushCustomerIdToProductForm",
                                        "type": "fnPushToArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "formData.fgFactoryForm.customer",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "fetchedData.factoryFgProductForm.q.customer"
                                      },
                                      "name": "pushCustomerIdToProductForm"
                                    },
                                    {
                                      "executionOrder": 3,
                                      "pageFunction": {
                                        "name": "getProducts",
                                        "type": "fnGetData",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v1/product/search",
                                        "arg2Key": "postData",
                                        "arg2Value": "fetchedData.factoryFgProductForm",
                                        "arg3Key": "storeInVar",
                                        "arg3Value": "fetchedData.fgFactoryProducts"
                                      },
                                      "name": "getProducts"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "items": "fetchedData.customers.data",
                                  "itemText": "name",
                                  "itemValue": "_id",
                                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                                },
                                {
                                  "type": "dropdown",
                                  "variable": "formData.fgFactoryForm.product",
                                  "label": "Filter By Product",
                                  "disabled": "FALSE",
                                  "onChange": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "copyDefaultFgPageNo",
                                        "type": "fnCopyData",
                                        "arg1Key": "sourceFn",
                                        "arg1Value": "getDefaultPageNo",
                                        "arg2Key": "destinationKey",
                                        "arg2Value": "formData.fgFactoryForm",
                                        "arg3Key": "append",
                                        "arg3Value": "TRUE",
                                        "arg4Key": "destinationKeyType",
                                        "arg4Value": "Object"
                                      },
                                      "name": "copyDefaultFgPageNo"
                                    },
                                    {
                                      "executionOrder": 3,
                                      "pageFunction": {
                                        "name": "getFgFactoryGoods",
                                        "type": "fnGetData",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/search",
                                        "arg2Key": "postData",
                                        "arg2Value": "formData.fgFactoryForm",
                                        "arg3Key": "storeInVar",
                                        "arg3Value": "fetchedData.factoryFg"
                                      },
                                      "name": "getFgFactoryGoods"
                                    },
                                    {
                                      "executionOrder": 4,
                                      "pageFunction": {
                                        "name": "createFactoryFgVariableArray",
                                        "type": "fnCreateArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "fetchedData.factoryFg.data.docs",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "formData.factory.FG",
                                        "arg3Key": "arrayTransformationFn",
                                        "arg3Value": "getFgVariable"
                                      },
                                      "name": "createFactoryFgVariableArray"
                                    }
                                  ],
                                  "items": "fetchedData.fgFactoryProducts.data.docs",
                                  "itemText": "alias",
                                  "itemValue": "_id",
                                  "formula": "fn(CONCAT,{{__item._id}}, ,fn(HELPER_FN,productAlias,{{__item}}))"
                                }
                              ]
                            },
                            {
                              "name": "2",
                              "pageItems": [
                                {
                                  "type": "table",
                                  "variable": "formData.factory.FG",
                                  "label": "factory",
                                  "disabled": "FALSE",
                                  "items": "fetchedData.factoryFg.data.docs",
                                  "headers": [
                                    {
                                      "value": "__item._id",
                                      "text": "FG#"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order._id",
                                      "text": "Order #",
                                      "type": "url",
                                      "url": "/order/{{__item.factoryTicket.order._id}}"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order.product._id",
                                      "text": "Product",
                                      "type": "formula",
                                      "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order.customer._id",
                                      "text": "Customer",
                                      "type": "formula",
                                      "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                                    },
                                    {
                                      "value": "__item.factoryTicket.order.unit.unit2",
                                      "text": "Selling Unit"
                                    },
                                    {
                                      "value": "__item.quantity",
                                      "text": "Quantity",
                                      "type": "text"
                                    }
                                  ],
                                  "tableType": "dynamic",
                                  "variableKey": "_id",
                                  "itemKey": "_id",
                                  "validationVariable": "factoryFG",
                                  "pagination": {
                                    "pageVariable": "formData.fgFactoryForm.page",
                                    "itemsPerPageVariable": "formData.fgFactoryForm.limit",
                                    "serverItemsLengthVariable": "fetchedData.factoryFg.data.totalDocs",
                                    "pageChangeFns": [
                                      {
                                        "executionOrder": 2,
                                        "pageFunction": {
                                          "name": "getFgFactoryGoods",
                                          "type": "fnGetData",
                                          "arg1Key": "apiUrl",
                                          "arg1Value": "/api/v2/goods/search",
                                          "arg2Key": "postData",
                                          "arg2Value": "formData.fgFactoryForm",
                                          "arg3Key": "storeInVar",
                                          "arg3Value": "fetchedData.factoryFg"
                                        },
                                        "name": "getFgFactoryGoods"
                                      },
                                      {
                                        "executionOrder": 3,
                                        "pageFunction": {
                                          "name": "createFactoryFgVariableArray",
                                          "type": "fnCreateArray",
                                          "arg1Key": "sourceVariable",
                                          "arg1Value": "fetchedData.factoryFg.data.docs",
                                          "arg2Key": "destinationVariable",
                                          "arg2Value": "formData.factory.FG",
                                          "arg3Key": "arrayTransformationFn",
                                          "arg3Value": "getFgVariable"
                                        },
                                        "name": "createFactoryFgVariableArray"
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "3",
                              "pageItems": [
                                {
                                  "type": "button",
                                  "label": "Submit",
                                  "onClick": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "createFactoryFgVariableFormArray",
                                        "type": "fnCreateArray",
                                        "arg1Key": "sourceVariable",
                                        "arg1Value": "formData.factory.FG",
                                        "arg2Key": "destinationVariable",
                                        "arg2Value": "formData.resolvedFactoryFG",
                                        "arg3Key": "arrayTransformationFn",
                                        "arg3Value": "getResolvedFgVariable"
                                      },
                                      "name": "createFactoryFgVariableFormArray"
                                    },
                                    {
                                      "executionOrder": 2,
                                      "pageFunction": {
                                        "name": "submitFactoryFGClosing",
                                        "type": "fnSubmit",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/closing-adjustment/Factory",
                                        "arg2Key": "postData",
                                        "arg2Value": "getFactoryFgData",
                                        "arg3Key": "refreshPage",
                                        "arg3Value": "TRUE"
                                      },
                                      "name": "submitFactoryFGClosing"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "color": "primary"
                                }
                              ]
                            }
                          ],
                          "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
                        },
                        {
                          "tabName": "WIP",
                          "bracketValueFormula": "{{fetchedData.factoryWip.data.totalDocs}}",
                          "rows": [
                            {
                              "name": "1",
                              "pageItems": [
                                {
                                  "type": "table",
                                  "variable": "formData.factory.WIP",
                                  "label": "factory",
                                  "disabled": "FALSE",
                                  "items": "fetchedData.factoryWip.data.docs",
                                  "headers": [
                                    {
                                      "value": "__item._id",
                                      "text": "WIP#"
                                    },
                                    {
                                      "value": "__item.details",
                                      "text": "Good Details",
                                      "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                                    },
                                    {
                                      "value": "__item.density",
                                      "text": "Density",
                                      "type": "formula",
                                      "formula": "{{__item.density}} {{__item.densityUnit}}"
                                    },
                                    {
                                      "value": "__item.quantity",
                                      "text": "Quantity",
                                      "type": "text"
                                    }
                                  ],
                                  "tableType": "dynamic",
                                  "variableKey": "_id",
                                  "itemKey": "_id",
                                  "validationVariable": "factoryWIP",
                                  "pagination": {
                                    "pageVariable": "formData.wipFactoryForm.page",
                                    "itemsPerPageVariable": "formData.wipFactoryForm.limit",
                                    "serverItemsLengthVariable": "fetchedData.factoryWip.data.totalDocs",
                                    "pageChangeFns": [
                                      {
                                        "executionOrder": 2,
                                        "pageFunction": {
                                          "name": "getWipFactoryGoods",
                                          "type": "fnGetData",
                                          "arg1Key": "apiUrl",
                                          "arg1Value": "/api/v2/goods/search",
                                          "arg2Key": "postData",
                                          "arg2Value": "formData.wipFactoryForm",
                                          "arg3Key": "storeInVar",
                                          "arg3Value": "fetchedData.factoryWip"
                                        },
                                        "name": "getWipFactoryGoods"
                                      },
                                      {
                                        "executionOrder": 3,
                                        "pageFunction": {
                                          "name": "createFactoryWipVariableArray",
                                          "type": "fnCreateArray",
                                          "arg1Key": "sourceVariable",
                                          "arg1Value": "fetchedData.factoryWip.data.docs",
                                          "arg2Key": "destinationVariable",
                                          "arg2Value": "formData.factory.WIP",
                                          "arg3Key": "arrayTransformationFn",
                                          "arg3Value": "getGoodsVariable"
                                        },
                                        "name": "createFactoryWipVariableArray"
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "2",
                              "pageItems": [
                                {
                                  "type": "button",
                                  "label": "Submit",
                                  "onClick": [
                                    {
                                      "executionOrder": 1,
                                      "pageFunction": {
                                        "name": "submitFactoryWIPClosing",
                                        "type": "fnSubmit",
                                        "arg1Key": "apiUrl",
                                        "arg1Value": "/api/v2/goods/closing-adjustment/Factory",
                                        "arg2Key": "postData",
                                        "arg2Value": "getFactoryWipData",
                                        "arg3Key": "refreshPage",
                                        "arg3Value": "TRUE"
                                      },
                                      "name": "submitFactoryWIPClosing"
                                    }
                                  ],
                                  "disabled": "FALSE",
                                  "color": "primary"
                                }
                              ]
                            }
                          ],
                          "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
          "pageFunction": {
          "name": "initialiseFormData",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "createInitialFormData",
          "arg2Key": "destinationKey",
          "arg2Value": "formData"
        },
        "name": "initialiseFormData"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultRmWarehouseQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultRmWarehouseQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.rmWarehouseForm"
        },
        "name": "copyDefaultRmWarehouseQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getRmWarehouseGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.rmWarehouseForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.warehouseRm"
        },
        "name": "getRmWarehouseGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "createWarehouseRmVariableArray",
          "type": "fnCreateArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.warehouseRm.data.docs",
          "arg2Key": "destinationVariable",
          "arg2Value": "formData.warehouse.RM",
          "arg3Key": "arrayTransformationFn",
          "arg3Value": "getGoodsVariable"
        },
        "name": "createWarehouseRmVariableArray",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultFgWarehouseQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFgWarehouseQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.fgWarehouseForm"
        },
        "name": "copyDefaultFgWarehouseQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getFgWarehouseGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.fgWarehouseForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.warehouseFg"
        },
        "name": "getFgWarehouseGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "createWarehouseFgVariableArray",
          "type": "fnCreateArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.warehouseFg.data.docs",
          "arg2Key": "destinationVariable",
          "arg2Value": "formData.warehouse.FG",
          "arg3Key": "arrayTransformationFn",
          "arg3Value": "getFgVariable"
        },
        "name": "createWarehouseFgVariableArray",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultWipWarehouseQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultWipWarehouseQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.wipWarehouseForm"
        },
        "name": "copyDefaultWipWarehouseQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getWipWarehouseGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.wipWarehouseForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.warehouseWip"
        },
        "name": "getWipWarehouseGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "createWarehouseWipVariableArray",
          "type": "fnCreateArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.warehouseWip.data.docs",
          "arg2Key": "destinationVariable",
          "arg2Value": "formData.warehouse.WIP",
          "arg3Key": "arrayTransformationFn",
          "arg3Value": "getGoodsVariable"
        },
        "name": "createWarehouseWipVariableArray",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultRmFactoryQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultRmFactoryQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.rmFactoryForm"
        },
        "name": "copyDefaultRmFactoryQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getRmFactoryGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.rmFactoryForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.factoryRm"
        },
        "name": "getRmFactoryGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "createFactoryRmVariableArray",
          "type": "fnCreateArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.factoryRm.data.docs",
          "arg2Key": "destinationVariable",
          "arg2Value": "formData.factory.RM",
          "arg3Key": "arrayTransformationFn",
          "arg3Value": "getGoodsVariable"
        },
        "name": "createFactoryRmVariableArray",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultFgFactoryQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFgFactoryQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.fgFactoryForm"
        },
        "name": "copyDefaultFgFactoryQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getFgFactoryGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.fgFactoryForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.factoryFg"
        },
        "name": "getFgFactoryGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "createFactoryFgVariableArray",
          "type": "fnCreateArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.factoryFg.data.docs",
          "arg2Key": "destinationVariable",
          "arg2Value": "formData.factory.FG",
          "arg3Key": "arrayTransformationFn",
          "arg3Value": "getFgVariable"
        },
        "name": "createFactoryFgVariableArray",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultWipFactoryQuery",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultWipFactoryQuery",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.wipFactoryForm"
        },
        "name": "copyDefaultWipFactoryQuery",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getWipFactoryGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/goods/search",
          "arg2Key": "postData",
          "arg2Value": "formData.wipFactoryForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.factoryWip"
        },
        "name": "getWipFactoryGoods",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "createFactoryWipVariableArray",
          "type": "fnCreateArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.factoryWip.data.docs",
          "arg2Key": "destinationVariable",
          "arg2Value": "formData.factory.WIP",
          "arg3Key": "arrayTransformationFn",
          "arg3Value": "getGoodsVariable"
        },
        "name": "createFactoryWipVariableArray",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      }
    ],
    "functions": [
            {
        "name": "createInitialFormData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "factory": "{}",
          "warehouse": "{}"
        },
        "useFormula": true
      },
      {
        "name": "getGoodsVariable",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "_id": "__selectedObject._id"
        }
      },
      {
        "name": "getFgVariable",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "_id": "__selectedObject._id",
          "fg": "__selectedObject"
        }
      },
      {
        "name": "getWarehouseRmData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "goods": "{{__variable}}"
        },
        "additionalVariable": "formData.warehouse.RM",
        "useFormula": true
      },
      {
        "name": "getWarehouseWipData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "goods": "{{__variable}}"
        },
        "additionalVariable": "formData.warehouse.WIP",
        "useFormula": true
      },
      {
        "name": "getWarehouseFgData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "goods": "{{__variable}}"
        },
        "additionalVariable": "formData.resolvedWhFG",
        "useFormula": true
      },
      {
        "name": "getFactoryRmData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "goods": "{{__variable}}"
        },
        "additionalVariable": "formData.factory.RM",
        "useFormula": true
      },
      {
        "name": "getFactoryWipData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "goods": "{{__variable}}"
        },
        "additionalVariable": "formData.factory.WIP",
        "useFormula": true
      },
      {
        "name": "getFactoryFgData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "goods": "{{__variable}}"
        },
        "additionalVariable": "formData.resolvedFactoryFG",
        "useFormula": true
      },
      {
        "name": "getDefaultRmWarehouseQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "",
          "page": 1,
          "limit": 20,
          "filters": {
            "status": "RM",
            "location.Warehouse.totalQuantity": { $gt: 0.001 }
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultRmFactoryQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "",
          "page": 1,
          "limit": 20,
          "filters": {
            "status": "RM",
            "location.Factory.totalQuantity": { $gt: 0.001 }
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultFgWarehouseQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "",
          "page": 1,
          "limit": 20,
          "filters": {
            "status": "FG",
            "location.Warehouse.totalQuantity": { $gt: 0.001 }
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultFgFactoryQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "",
          "page": 1,
          "limit": 20,
          "filters": {
            "status": "FG",
            "location.Factory.totalQuantity": { $gt: 0.001 }
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultWipWarehouseQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "",
          "page": 1,
          "limit": 20,
          "filters": {
            "status": "WIP",
            "location.Warehouse.totalQuantity": { $gt: 0.001 }
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultWipFactoryQuery",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "",
          "page": 1,
          "limit": 20,
          "filters": {
            "status": "WIP",
            "location.Factory.totalQuantity": { $gt: 0.001 }
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPageNo",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1
        },
        "staticObject": true
      },
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {},
          "page": 1
        },
        "staticObject": true,
      },
      {
        "name": "getResolvedFgVariable",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "_id": "{{__selectedObject._id}}",
          "quantity": "fn(HELPER_FN,sellingUnitQuantityToKg,{{__selectedObject.fg}},{{__selectedObject.quantity}},{{__selectedObject.fg.factoryTicket.order.unit.unit2}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE",
  "visible": true
}